<template>
  <div class="content">
    <FilterRestaurantsForBooking class="filter" />
    <template v-if="isLoading === false && items.length === 0">
      <div class="content-empty">
        <span>
          По вашему запросу заведений не найдено, измените параметры поиска
        </span>
      </div>
    </template>
    <template v-else>
      <perfect-scrollbar class="items" ref="scrollbarApi">
        <template v-if="screenType === 'mobile'">
          <template v-if="isLoading">
            <RestaurantCardMobileSkeleton
              class="item"
              v-for="item in 3"
              :key="item"
            />
          </template>
          <template v-else>
            <RestaurantCardMobile
              class="item"
              v-for="item in items"
              :key="item.id"
              :restaurant="item"
              @click="onCardClickHandler(item.id)"
            />
          </template>
        </template>
        <template v-else>
          <template v-if="isLoading">
            <RestaurantCardSkeleton
              class="item"
              v-for="item in 3"
              :key="item"
            />
          </template>
          <template v-else>
            <RestaurantCard
              class="item"
              v-for="item in items"
              :key="item.id"
              :restaurant="item"
            />
          </template>
        </template>
        <div ref="observer" style="height: 1px"></div>
      </perfect-scrollbar>
    </template>
  </div>
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import RestaurantCard from "@/components/pages/restaurants/RestaurantCard.vue";
import FilterRestaurantsForBooking from "@/components/pages/home/FilterRestaurantsForBooking.vue";
import { API_WITHOUT_GUARDS } from "@/assets/js/api/apiWithoutGuards";
import RestaurantCardMobile from "@/components/pages/restaurants/RestaurantCardMobile.vue";
import RestaurantCardMobileSkeleton from "@/components/pages/restaurants/RestaurantCardMobileSkeleton.vue";
import RestaurantCardSkeleton from "@/components/pages/restaurants/RestaurantCardSkeleton.vue";

export default {
  name: "RestaurantList",
  components: {
    RestaurantCardSkeleton,
    RestaurantCardMobileSkeleton,
    RestaurantCardMobile,
    FilterRestaurantsForBooking,
    RestaurantCard,
    PerfectScrollbar,
  },

  data() {
    return {
      items: [],
      page: 1,
      perPage: 10,
      observer: null,
      pagesCount: 1,
      isLoading: true,
      isLoadedFirst: true,
      initItemsLock: null,
    };
  },

  computed: {
    screenType() {
      return this.$store.getters.screenType;
    },
    initItems() {
      return this.$store.state.clientRestaurants.filteredItems;
    },
    scrollPosition() {
      return this.$store.state.clientRestaurants.listScrollbarTop;
    },
  },

  watch: {
    initItems: {
      async handler(value) {
        this.initItemsLock = this.initItemsLock || Promise.resolve();
        this.initItemsLock = this.initItemsLock.then(async () => {
          if (this.isLoadedFirst && value.length === 0) {
            this.items = [];
            this.isLoadedFirst = false;
            return;
          }
          this.items = [];
          this.page = 1;
          if (value && value.length) {
            this.pagesCount = Math.ceil(value.length / this.perPage);
          }
          this.unsubscribeObserver();
          if (value.length) {
            await this.loadMoreItems();
          } else {
            this.isLoading = false;
          }
          if (value.length > 10) {
            this.subscribeObserver();
          }
        });
      },
      immediate: true,
    },
  },

  methods: {
    onCardClickHandler(id) {
      this.$store.commit({
        type: "setListScrollbarTop",
        value: this.$refs.scrollbarApi.$data.ps.lastScrollTop,
      });
      this.$router.push(`/${id}`);
    },
    handleObserver(entries) {
      if (entries[0].isIntersecting) {
        this.page++;
        this.loadMoreItems();
      }
    },
    async loadMoreItems() {
      if (!this.initItems?.length || this.page > this.pagesCount) {
        this.loading = false;
        return;
      }

      const start = (this.page - 1) * this.perPage;
      const end = this.page * this.perPage;
      const initItems = this.initItems;
      const items = [];

      for (let i = start; i < end; i++) {
        if (initItems[i]) {
          items.push(initItems[i]);
        }
      }

      if (items.length) {
        if (this.page < 2) {
          this.isLoading = true;
        }

        try {
          const res = await API_WITHOUT_GUARDS.client.getCateringsById({
            cats: items.map((el) => el.id),
          });
          const resultItems = res.data.map((item) => {
            return {
              ...item,
              available: items.find((el) => el.id === item.id).available,
              workingToday: items.find((el) => el.id === item.id).workingToday,
            };
          });
          this.items.push(...resultItems);
        } catch (e) {
          console.log(e);
        } finally {
          this.isLoading = false;
        }
      } else {
        this.isLoading = false;
      }
    },
    unsubscribeObserver() {
      if (this.observer) {
        this.observer.unobserve(this.$refs.observer);
        this.observer.disconnect();
        this.observer = null;
      }
    },
    subscribeObserver() {
      this.observer = new IntersectionObserver(this.handleObserver, {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      });
      this.observer.observe(this.$refs.observer);
    },

    scrollToPosition() {
      this.$refs.scrollbarApi.ps.element.scrollTop = this.scrollPosition;
      this.$refs.scrollbarApi.ps.update();
    },
  },

  mounted() {
    setTimeout(() => {
      if (!this.initItems?.length) {
        this.isLoading = false;
      }
    }, 5000);
    if (this.scrollPosition) {
      this.scrollToPosition();
    }
  },

  beforeUnmount() {
    this.unsubscribeObserver();
  },
};
</script>

<style scoped lang="scss">
.content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-left: 336px;

  @include mobile {
    padding-top: 0;
    padding-left: 0;
  }
}

.items {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: min-content;
  min-height: 100%;
  padding: 96px 22px 52px 16px;
  background: #f6f6f6;
  overflow: auto;
  gap: 24px;

  @include l-laptop {
    padding-top: 144px;
  }

  @include mobile {
    height: 100%;
    width: 100%;
    padding: 0 16px 100px 16px;
    gap: 16px;
  }

  .item {
    &:first-child {
      @include mobile {
        margin-top: 156px;
      }
    }
    box-shadow: 0 0 8px 0 #00000014;
  }
}

.content-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #f6f6f6;

  span {
    max-width: 452px;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    text-align: center;

    @include mobile {
      max-width: 296px;
      font-size: 16px;
      line-height: 22px;
    }
  }
}

.input {
  width: 100%;
  height: 40px;
  margin-right: 16px;
}
</style>
